__webpack_require__.p = "/sonko-patriot-forge-docs/";